import { createFileRoute } from '@tanstack/react-router'

import { BrokersPage } from '#/modules/fmcsa/brokers-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/brokers/')({
  component: BrokersPage,
  validateSearch: validateListSearch,
})
